/**
 * GET Travelers Action
 */
import * as _ from 'lodash-es';

import {
  ACTION_GET_TRAVELER,
  ACTION_GET_TRAVELER_SUCCESS,
  ACTION_GET_TRAVELER_FAILURE,
  ACTION_EMPTY_TRAVELER,
  API_CALL,
} from '../../configs/ActionTypes';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../Status';

/**
 * POST Users Request Action
 */
export function getSingle(travelerId: string) {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    dispatch({
      type: API_CALL,
      payload: {
        call: `traveler/${travelerId}`,
        method: 'get',
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          enqueueSnackbarHandler(dispatch, error.payload, 'error');
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_TRAVELER,
    payload: null,
  };
}

export function requestSuccess(responeJSON: any) {
  return {
    type: ACTION_GET_TRAVELER_SUCCESS,
    payload: responeJSON,
  };
}

export function requestFailed(responeJSON: object) {
  return {
    type: ACTION_GET_TRAVELER_FAILURE,
    payload: responeJSON,
  };
}

export function emptyTraveler() {
  return (dispatch: Dispatch) => {
    dispatch({
      type: ACTION_EMPTY_TRAVELER,
      payload: null,
    });
  };
}
